import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const CalendarWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  height: 700,
  '& .fc': {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
  },
  '& .fc-event': {
    cursor: 'pointer',
  },
  '& .fc-button-primary': {
    backgroundColor: `${theme.palette.primary.main} !important`,
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.contrastText} !important`,
    fontFamily: `${theme.typography.fontFamily} !important`,
    fontWeight: '500 !important',
    fontSize: '0.875rem !important',
    lineHeight: '1.75 !important',
    letterSpacing: '0.02857em !important',
    textTransform: 'uppercase !important',
    padding: '0.375rem 0.75rem !important',
    border: '1px solid transparent !important',
    transition: theme.transitions.create(
      ['background-color', 'box-shadow', 'border-color', 'color'],
      {
        duration: 250,
      }
    ),
    boxShadow:
      '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.dark} !important`,
      borderColor: `${theme.palette.primary.dark} !important`,
    },
    '&:active': {
      backgroundColor: `${theme.palette.primary.dark} !important`,
      borderColor: `${theme.palette.primary.dark} !important`,
    },
    '&:disabled': {
      backgroundColor: `${theme.palette.action.disabledBackground} !important`,
      color: `${theme.palette.action.disabled} !important`,
    },
  },
  '& .fc-toolbar-title': {
    color: theme.palette.text.primary,
  },
  '& .fc-col-header-cell-cushion': {
    color: theme.palette.text.primary,
    textDecoration: 'none',
  },
  '& .fc-daygrid-day-number': {
    color: theme.palette.text.primary,
    textDecoration: 'none',
  },
  ...(theme.palette.mode === 'dark' && {
    '--fc-page-bg-color': theme.palette.background.default,
    '--fc-border-color': theme.palette.divider,
    '--fc-neutral-bg-color': theme.palette.action.hover,
    '--fc-list-event-hover-bg-color': theme.palette.action.hover,
    '--fc-today-bg-color': theme.palette.action.selected,
    '& .fc-theme-standard td, & .fc-theme-standard th': {
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.default,
    },
    '& .fc-theme-standard .fc-scrollgrid': {
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.default,
    },
    '& .fc-day-today': {
      backgroundColor: `${theme.palette.action.selected} !important`,
    },
    '& .fc-list-day-cushion': {
      backgroundColor: theme.palette.background.default,
    },
    '& .fc-list-event:hover td': {
      backgroundColor: theme.palette.action.hover,
    },
    '& .fc-popover': {
      backgroundColor: `${theme.palette.background.paper} !important`,
      borderColor: `${theme.palette.divider} !important`,
      boxShadow: `${theme.shadows[4]} !important`,
    },
    '& .fc-popover-header': {
      backgroundColor: `${theme.palette.background.default} !important`,
      color: `${theme.palette.text.primary} !important`,
    },
    '& .fc-popover-body': {
      color: `${theme.palette.text.primary} !important`,
    },
    '& .fc-more-popover': {
      backgroundColor: `${theme.palette.background.paper} !important`,
      borderColor: `${theme.palette.divider} !important`,
    },
    '& .fc-day-past': {
      backgroundColor: theme.palette.action.hover,
    },
  }),
}));
